module.exports = __webpack_public_path__ + "img/bg7.49b057a1.png";